<template>
  <div class="w100 pt10 pb10 main-box comment">
    <div class="w120 mc pt20 pb20" v-for="item in moduleData.cardModules" :key="item.code">
      <div class="flex-box">
        <div class="flex-1">
          <span class="font-24 comment-title">服务评价</span>
          <span class="ml20 font-16 grey">本月统计数据</span>
        </div>
        <div>
          <!-- <el-date-picker v-model="moon" type="month" placeholder="选择月份" :clearable="false"></el-date-picker> -->
        </div>
      </div>

      <div class="flex-box al-c count-box">
        <div class="pl20 pr20 flex-2 bor-r">
          <p class="mb20 font-16 item-title">评价次数</p>
          <p class="item-tx">
            <span class="font-40">{{item.data.serCommAllCnt}}</span>
            <span class="ml10 font-16">次</span>
          </p>
        </div>
        <div class="pl20 pr20 flex-2 bor-r">
          <p class="mb20 font-16 item-title">好评次数</p>
          <p class="item-tx">
            <span class="font-40">{{item.data.serCommGoodCnt}}</span>
            <span class="ml10 font-16">次</span>
          </p>
        </div>
        <div class="pl20 pr20 flex-2 bor-r">
          <p class="mb20 font-16 item-title">办理时效</p>
          <p class="item-tx">
            <span class="font-40">{{item.data.serHanldHourCnt}}</span>
            <span class="ml10 font-16">小时</span>
          </p>
        </div>
        <div class="pl20 pr20 flex-3">
          <p class="mb20 font-16 item-title">办理评分</p>
          <p class="flex-box al-b item-tx">
            <span class="font-40">{{item.data.serAvgScore.substring(0,item.data.serAvgScore.length-1)}}</span>
            <span class="ml10 pb5 font-16">分</span>
            <span class="ml10 pb5">
              <el-rate :value="Number(item.data.serAvgScore.substring(0,item.data.serAvgScore.length-1))" disabled></el-rate>
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "COMMENT",
  components: {},
  props: ['moduleData'],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      moon: new Date(),
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {},
  watch: {},
  filters: {},
};
</script>

<style scoped>
.main-box {
  height: 350px;
  background: no-repeat center center;
}

.count-box {
  margin-top: 30px;
  padding: 48px 30px 60px 30px;
  background: rgba(255, 255, 255, 0.16);
}
</style>
